import React from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';

interface AppFormProps extends React.HTMLProps<HTMLDivElement> {
  initialValues: any;
  onSubmit(values: any): void;
  validationSchema: any;
  children?: any;
  onValidation?(valid: boolean): void;
  onChange?(values: any): void;
  ignoreInitialValidation?: boolean;
}

function AppForm({
  initialValues,
  onSubmit,
  validationSchema,
  children,
  onValidation,
  ignoreInitialValidation = false,
  onChange,
  ...rest
}: AppFormProps) {
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validateOnChange
      validationSchema={validationSchema}>
      {({
        isValid,
        isInitialValid,
        dirty,
        values,
        validateForm,
        errors,
        setFieldValue,
      }) => {
        if (onValidation) {
          if (dirty || ignoreInitialValidation) {
            onValidation(isValid);
          } else {
            onValidation(!!isInitialValid);
          }
        }
        if (onChange) {
          onChange(values);
        }
        return <div {...rest}>{children}</div>;
      }}
    </Formik>
  );
}

export default AppForm;
